// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"904b3e25","223":"8d34aa02","292":"71ddcaa2","387":"1dd5f0f4","414":"496eff6f","420":"90e5373e","602":"cbcc2eb2","642":"99301ed4","654":"c802b3c4","766":"48d0dd7a","795":"de8ebd17","823":"4885150e","938":"ff97fc94","979":"4acf76bd"}[chunkId] + ".chunk.js";
};